import { useMutation } from '@tanstack/react-query';
import apiUpdateService from 'services/apiUpdateService';
import { ISetActivityItemsConfig } from './@types';

const setActivityItemsConfig = async (dataUpdate: {
  data: ISetActivityItemsConfig[];
  subscription: string;
}) => {
  const { data } = await apiUpdateService.patch(
    `activitiesItemsConfig/activitiesLevels?subscription=${dataUpdate.subscription}`,
    dataUpdate.data,
  );

  return data;
};

export const useSetActivityItemsConfig = (options?: any) => {
  return useMutation(setActivityItemsConfig, {
    ...options,
  });
};
